import config from '../config';

let authToken = '';
export const setAuthToken = token => (authToken = token);

export const getUserStatus = ({ authCode, refreshToken, redirectUrl }) => {
  return fetch(
    `${config.apiUrl}/mystatus?code=${authCode}&&refreshToken=${refreshToken}&&redirectUrl=${redirectUrl}`
  ).then(response => response.json());
};

export const loadBoards = () => {
  return fetch(`${config.apiUrl}/client/board`, {
    headers: { Authorization: `Bearer ${authToken}` }
  }).then(response => response.json());
};

export const createBoard = async ({ templateId = null } = {}) => {
  try {
    const { projectId: boardId } = await fetch(`${config.apiUrl}/client/board`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ templateId })
    }).then(response => response.json());

    return boardId;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteBoard = boardId => {
  return fetch(`${config.apiUrl}/client/board/${boardId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${authToken}` }
  });
};

export const loadTemplates = () => {
  return fetch(`${config.apiUrl}/client/templates`, {
    headers: { Authorization: `Bearer ${authToken}` }
  }).then(response => response.json());
};

export const loadBoardPermissions = async boardId => {
  return fetch(`${config.apiUrl}/client/board/${boardId}/permissions`, {
    headers: { Authorization: `Bearer ${authToken}` }
  }).then(response => response.json());
};

export const shareBoard = async ({ boardId, role, emails }) => {
  return fetch(`${config.apiUrl}/client/board/${boardId}/permissions/add`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ role, emails })
  }).then(response => response.json());
};

export const unshareBoard = async ({ boardId, role, userIds }) => {
  return fetch(`${config.apiUrl}/client/board/${boardId}/permissions/remove`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ role, userIds })
  }).then(response => response.json());
};
